import React from "react";

const Button = (props) => {

    return (
        <button className={`btn btn-main ${props.className}`} style={props.style ?? {}} disabled={props.disabled ?? false} onClick={props.onClick ?? null} type={props.type ?? 'submit'}>{props.children}</button>
    )
}

export default Button;